<template>
  <el-container class="h-full" :class="{ 'large-font-mode': largeFontMode }">
    <!--  主页面 start  -->
    <el-main style="height: 100%">
      <div class="flex flex-row h-full">
        <!--    挂号 start    -->
        <el-card class="register-con self-stretch">
          <!--     logo start     -->
          <!-- <div class="flex flex-col cursor-pointer" @click="enroll">
            <img
              src="@/assets/treatment/register.png"
              alt=""
              class="register-logo"
            >
          </div> -->
          <!--     logo end     -->
          <!--      病人 start    -->
          <patients ref="patients" style="width: 176px" />
          <!--      病人 end    -->
        </el-card>
        <!--    挂号 end    -->
        <!--    诊疗 start    -->
        <div v-if="activePatientInfo && Object.keys(activePatientInfo).length" class="treatment-con" style="display: flex; flex-direction: column; height: 100%;">
          <el-card>
            <template>
              <div class="patient-header">
                <!-- 左侧区域 -->
                <div class="header-left">
                  <img
                    src="@/assets/treatment/profile-img.png"
                    class="header-avatar"
                    alt="头像"
                  >
                  <div class="header-info">
                    <div class="info-row">
                      <span class="patient-name">{{ activePatientInfo.name || "-" }}</span>
                      <span class="patient-meta">{{ activePatientInfo.sexSign ==='1'?'男':'女' }}/{{ calculateAge(activePatientInfo.birthDate) }}岁</span>

                      <!-- 体质标签 - 已移除，该接口返回用户不存在 -->
                      <el-tag
                        type="info"
                        size="small"
                        effect="plain"
                      >
                        <i class="el-icon-question" />
                        未辨识
                      </el-tag>

                      <span class="patient-phone">{{ activePatientInfo.contactPhone || "-" }}</span>
                    </div>

                    <!-- 备注标签行 -->
                    <div v-if="activePatientInfo.label || activePatientInfo.patientRemark" class="tag-row">
                      <el-tag v-if="activePatientInfo.label" size="small" type="primary">
                        <i class="el-icon-s-order" /> {{ activePatientInfo.label }}
                      </el-tag>
                      <el-tag v-if="activePatientInfo.patientRemark" size="small" type="info">
                        <i class="el-icon-edit-outline" /> {{ activePatientInfo.patientRemark }}
                      </el-tag>
                    </div>
                  </div>
                </div>

                <!-- 右侧区域 -->
                <div class="header-right">
                  <div class="info-line info-with-action">
                    <div class="info-group">
                      <span class="info-item">
                        <label>出生日期：</label>
                        <value>{{ activePatientInfo.birthDate || '未知' }}</value>
                      </span>
                      <span class="divider">|</span>
                      <span class="info-item">
                        <label>就诊状态：</label>
                        <value :class="'state-'+activeDiagRecord.diagRecord.stateSign">
                          {{ getStateText(activeDiagRecord.diagRecord.stateSign) }}
                        </value>
                      </span>
                      <span class="divider">|</span>
                      <span class="info-item">
                        <label>病历号：</label>
                        <value>{{ activeDiagRecord.diagRecord.code || '-' }}</value>
                      </span>
                    </div>
                  </div>

                  <div class="info-line secondary-line">
                    <span v-if="activePatientInfo.contactAddress" class="info-item">
                      <label>地址：</label>
                      <value>{{ activePatientInfo.contactAddress }}</value>
                    </span>
                    <span v-else class="placeholder" />
                  </div>
                </div>
              </div>
            </template>
          </el-card>
          <el-card class="history-container">
            <div class="flex flex-row w-full">
              <!-- 历史部分 占70% -->
              <div class="w-7/10 history-section" style="width: 100%; height: 70vh;">
                <div v-if="hisTreatmentRecords.length>0" class="history-content">
                  <div class="diagnosis-record-con">
                    <el-timeline class="history-timeline">
                      <el-timeline-item
                        v-for="record in hisTreatmentRecords"
                        :key="record.id"
                        type="primary"
                      >
                        <diagnosis-record
                          :record="record"
                          class="record"
                          @command="handleDiagnosisRecord"
                        />
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
                <div v-else class="no-data flex flex-col w-full align-center justify-center">
                  <span class="no-data-label">抱歉, 暂无相关数据</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
        <div v-else class="no-patient-tip" style="flex: 1; display: flex; align-items: center; justify-content: center; color: #999;">
          请从左侧选择一位病人开始诊疗
        </div>
        <!--    诊疗 end    -->
      </div>
    </el-main>
    <!--  主页面 end  -->
  </el-container>
</template>

<script>
import DiagnosisRecord from "@/views/business/page/treatment/treatment/diagnosisRecord/DiagnosisRecord.vue"
import Patients from "@/views/business/page/treatment/treatment/patients/inspectionPatients.vue"
import { postData } from "@/api/user/authApi"
import { getByCode } from "@/api/ik/data/dataApi"
import { findAll } from "@/api/ik/data/dataApi"
export default {
  name: "Index",
  components: {
    DiagnosisRecord,
    Patients
  },
  filters: {
    PAY_WAY(payWay) {
      switch (payWay) {
        case "wechat":
          return "微信"
        case "aliPay":
          return "支付宝"
      }
    }
  },
  data() {
    return {
      // 医生列表
      doctorListLoading: false,
      doctorList: [],
      type: this.$route.query.type,
      largeFontMode: false,
      // --- 挂号 ---
      // 挂号弹窗
      enrollVisible: false,
      // --- 病人信息 ---
      // 就诊记录
      diagRecords: [],
      // 当前病人信息
      activePatientInfo: {},
      // 历史诊疗记录
      hisTreatmentRecords: [],
      // 当前就诊信息tab
      activeDiagTab: "reDiag",
      // 当前就诊记录
      activeDiagRecord: {
        preTreatmentRecord: null,
        diagRecord: {
          code: ""
        },
        treatmentRecord: {
          // 病历
          symContent: "", // 主诉关键字
          hisContent: "", // 既往史关键字
          familyContent: "", // 家族史关键字
          phyContent: "", // 体质关键字
          fdmContent: "", // 四诊关键字
          diagContent: "", // 诊断关键字
          chDiagContent: "", // 中医病关键字
          chYndromeContent: "", // 中医症关键字
          chTherapyContent: "", // 治法关键字
          highPressure: 0, // 血压高值
          lowPressure: 0, // 血压低值
          bloodSugar: 0, // 血糖
          temperature: 0, // 体温
          // 治疗
          medPositionCode: "", // 中成药药库编码
          medPositionName: "", // 中成药药库名称
          chmedPositionCode: "", // 饮片处方药库编码
          chmedPositionName: "", // 饮片处方药库名称
          servePositionCode: "", // 理疗安排药库编码
          doseNum: 0, // 总剂数
          dayDoseNum: 0, // 次/日
          dayFreq: 0, // 剂/日
          serveFeeSign: "00" // 加工方式
          // 00 不加工 01 代煎 11 制粒
          // 21 细粉打粉 22 粗粉打粉
          // 31 水丸制丸 32 蜜丸制丸 33 大蜜丸制丸 35 水蜜丸制丸
          // 41 制瓶装膏 42 制袋装膏 43 制块装膏},
        },
        chmedPrescription: {
          positionCode: "",
          positionName: "",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0,
          serveFeeSign: "00" // 加工方式
          // 00 不加工 01 代煎 11 制粒
          // 21 细粉打粉 22 粗粉打粉
          // 31 水丸制丸 32 蜜丸制丸 33 大蜜丸制丸 35 水蜜丸制丸
          // 41 制瓶装膏 42 制袋装膏 43 制块装膏},
        },
        djPrescription: { // 代煎处方
          pharmacyCode: "",
          pharmacyName: "",
          serveFeeSign: "00",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0
        },
        dsPrescription: { // 代售处方
          pharmacyCode: "",
          pharmacyName: "",
          doseNum: 0,
          dayDoseNum: 0
        },
        chmedPrescriptionItemList: [],
        medPrescription: {
          positionCode: "",
          positionName: ""
        },
        medPrescriptionItemList: [],
        servePrescriptionItemList: [],
        djPrescriptionItemList: [],
        dsPrescriptionItemList: []
      },
      // --- 病历与治疗 ---
      // 开方关键词 用空格拼接
      searchKeyWord: "",
      // 配药弹窗
      prepareVisible: false,
      // 支付结算弹窗
      payVisible: false,
      // 发药弹窗
      dispatchVisible: false,
      // 就诊记录编码
      diagCode: "",
      // 二维码弹窗
      qrcodeVisible: false,
      // 支付方式
      payWay: "",
      // 出库单
      outOrdList: [],
      // --- 发药 ---
      // 饮片处方发药清单
      sendChmedList: [],
      // 中成药发药清单
      sendMedList: [],
      // 饮片发药处方
      chmedPrescription: {},
      // 中成药发药处方
      medPrescription: {},
      liliaoPrescription: {},
      djPrescription: {},
      dsPrescription: {},
      cardShow: true,
      currentTreatmentTab: '1' // 新增：保存当前治疗标签页
    }
  },
  computed: {
    storeCode() {
      return this.$store.getters['user/getStoreCode']
    },
    storeUserCode() {
      return this.$store.getters['user/getUserCode']
    }
  },
  watch: {
    '$route.query.type'(newType) {
    // 当路由中的type参数变化时，更新组件的type值
      this.type = newType
    }
  },
  provide() {
    return {
      pageData: this
    }
  },
  created() {
    // 初始化时读取本地存储
    this.largeFontMode = localStorage.getItem('largeFontMode') === 'true'
    // 同步到根元素
    document.documentElement.setAttribute('data-large-font', this.largeFontMode)
    if (this.activeDiagRecord.treatmentRecord.code) {
      this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
    }
    this.getDoctorList()
  },
  methods: {
    calculateAge(birthDateStr) {
      if (!birthDateStr) return '-'
      const birthDate = new Date(birthDateStr)
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      if (today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age < 0 ? 0 : age
    },
    getStateText(stateSign) {
      const stateMap = {
        '1': '待诊断',
        '2': '已开方',
        '3': '已配药',
        '4': '待发药'
      }
      return stateMap[stateSign] || '未知'
    },
    handleTreatmentTabChange(key) {
      this.currentTreatmentTab = key // 保存当前标签页
    },
    toggleLargeFont() {
      this.largeFontMode = !this.largeFontMode
      localStorage.setItem('largeFontMode', this.largeFontMode)
      document.documentElement.setAttribute('data-large-font', this.largeFontMode)
      // 通知所有子组件更新
      this.$emit('large-font-changed', this.largeFontMode)
    },
    getDoctorList() {
      const url = "base/user/user/storeuser"
      const pd = {
        storeCode: this.storeCode,
        doctorTypeSign: '1',
        stateSign: '2'
      }
      this.doctorListLoading = true
      findAll(url, pd)
        .then(res => {
          this.doctorList = res.data
        })
        .finally(() => {
          this.doctorListLoading = false
        })
    },
    /**
     * 重置就诊记录
     */
    resetActiveDiagRecord() {
      this.activeDiagRecord = {
        preTreatmentRecord: null,
        diagRecord: {
          code: ""
        },
        treatmentRecord: {
          // 病历
          symContent: "", // 主诉关键字
          hisContent: "", // 既往史关键字
          familyContent: "", // 家族史关键字
          phyContent: "", // 体质关键字
          fdmContent: "", // 四诊关键字
          diagContent: "", // 诊断关键字
          chDiagContent: "", // 中医病关键字
          chYndromeContent: "", // 中医症关键字
          chTherapyContent: "", // 治法关键字
          highPressure: 0, // 血压高值
          lowPressure: 0, // 血压低值
          bloodSugar: 0, // 血糖
          temperature: 0, // 体温
          // 治疗
          medPositionCode: "", // 中成药药库编码
          medPositionName: "", // 中成药药库名称
          chmedPositionCode: "", // 饮片处方药库编码
          chmedPositionName: "", // 饮片处方药库名称
          servePositionCode: "", // 理疗安排药库编码
          doseNum: 0, // 总剂数
          dayDoseNum: 0, // 次/日
          dayFreq: 0, // 剂/日
          serveFeeSign: "00" // 加工方式
          // 00 不加工 01 代煎 11 制粒
          // 21 细粉打粉 22 粗粉打粉
          // 31 水丸制丸 32 蜜丸制丸 33 大蜜丸制丸 35 水蜜丸制丸
          // 41 制瓶装膏 42 制袋装膏 43 制块装膏},
        },
        chmedPrescription: {
          positionCode: "",
          positionName: "",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0,
          serveFeeSign: "00" // 加工方式
          // 00 不加工 01 代煎 11 制粒
          // 21 细粉打粉 22 粗粉打粉
          // 31 水丸制丸 32 蜜丸制丸 33 大蜜丸制丸 35 水蜜丸制丸
          // 41 制瓶装膏 42 制袋装膏 43 制块装膏},
        },
        djPrescription: { // 代煎处方
          pharmacyCode: "",
          pharmacyName: "",
          serveFeeSign: "00",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0
        },
        dsPrescription: { // 代售处方
          pharmacyCode: "",
          pharmacyName: "",
          doseNum: 0,
          dayDoseNum: 0
        },
        chmedPrescriptionItemList: [],
        medPrescription: {
          positionCode: "",
          positionName: ""
        },
        medPrescriptionItemList: [],
        servePrescriptionItemList: [],
        djPrescriptionItemList: [],
        dsPrescriptionItemList: []
      }
      this.searchKeyWord = ""
    },
    /**
     * 发药弹窗
     */
    dispatchMed() {
      const pd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      postData('clinic/treatment/treatment/diagrecord/do/virtualsend', pd).then(res => {
        if (res.data) {
          if (this.activeDiagRecord.chmedPrescription.outOrdCode) {
            const chmedCode = this.activeDiagRecord["chmedPrescription"]["outOrdCode"]
            getByCode("clinic/inventory/change/outord", chmedCode)
              .then(res => {
                this.sendChmedList = res.data.body["outOrdItem"]
                this.activeDiagRecord.chmedPrescription = { ...this.activeDiagRecord.chmedPrescription, ...res.data }
              })
          }
          if (this.activeDiagRecord.medPrescription.outOrdCode) {
            const medCode = this.activeDiagRecord["medPrescription"]["outOrdCode"]
            getByCode("clinic/inventory/change/outord", medCode)
              .then(res => {
                this.sendMedList = res.data.body["outOrdItem"]
                this.activeDiagRecord.medPrescription = {
                  ...this.activeDiagRecord.medPrescription,
                  ...res.data
                }
              })
          }
          this.dispatchVisible = true
        } else {
          this.$message.success('无发药流程，诊断完成')
          this.updateDiagRecord()
          this.updatePatientInfo()
        }
      })
    },
    /**
     * 重诊
     */
    resetDiag() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/resetdiag", pd)
        .then(res => {
          this.prepareVisible = false
          this.$message.success("重诊成功")
          this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
          console.log(this.activeDiagRecord)
        })
    },
    /**
     * 支付
     */
    pay() {
      this.payVisible = true
    },
    prescriptionConfirmation() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/treatmentcheckprescription", pd)
        .then(res => {
          this.prepareVisible = false
          this.$message.success("确认成功")
        })
    },
    /**
 * 配药
 */
    prepareMed() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      const treatPd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }

      // 判断是否需要执行initoutord接口（chmed或med处方有数据）
      const hasChmedOrMed = this.activeDiagRecord.chmedPrescriptionItemList.length > 0 ||
                        this.activeDiagRecord.medPrescriptionItemList.length > 0
      // 判断是否需要执行treatmentcheckprescription接口（dj或ds处方有数据）
      const hasDjOrDs = this.activeDiagRecord.djPrescriptionItemList.length > 0 ||
                   this.activeDiagRecord.dsPrescriptionItemList.length > 0

      // 需要执行的接口列表
      const requests = []
      console.log(hasDjOrDs)

      // 根据条件添加接口请求
      if (hasChmedOrMed) {
        requests.push(postData("clinic/treatment/treatment/diagrecord/do/initoutord", pd))
      }
      if (hasDjOrDs) {
        requests.push(postData("pharmacy/storage/agentpre/agentprescription/do/treatmentcheckprescription", pd))
      }

      // 执行所有需要的请求
      Promise.all(requests)
        .then(() => {
          // 所有接口执行成功后获取治疗记录
          return this.$refs.treatment.getTreatmentRecord(treatPd.code)
        })
        .then(res => {
          this.$message.success('操作成功')
          // 仅在有需要时打开配药弹窗（保持原有逻辑）
          // this.prepareVisible = true
        })
        .catch(err => {
          console.error("配药操作失败:", err)
          this.$message.error('操作失败，请重试')
        })
    },
    peiyao() {
      // 检查是否有任意处方内容不为空
      const hasPrescriptionContent = [
        this.activeDiagRecord.chmedPrescriptionItemList,
        this.activeDiagRecord.medPrescriptionItemList,
        this.activeDiagRecord.servePrescriptionItemList,
        this.activeDiagRecord.djPrescriptionItemList,
        this.activeDiagRecord.dsPrescriptionItemList
      ].some(list => list && list.length > 0)

      if (!hasPrescriptionContent) {
        this.$message.warning('请先填写处方内容')
        return
      }
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      const treatPd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      if (this.activeDiagRecord.diagRecord.stateSign === "2") {
        postData("clinic/treatment/treatment/diagrecord/do/dispensing", pd)
          .then(() => {
            this.prepareVisible = true
          })
          .finally(() => {
            this.updateDiagRecord()
            this.updatePatientInfo()
          })
      } else {
        this.$refs.treatment.getTreatmentRecord(treatPd.code)
        this.prepareVisible = true
      }
    },
    /**
     * 诊疗记录指令处理
     * @param command
     */
    handleDiagnosisRecord(command) {
      console.log(command)

      switch (command.type) {
        case "copyChmed":
          this.activeDiagRecord.treatmentRecord.doseNum = command.data.head.doseNum
          this.activeDiagRecord.treatmentRecord.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.treatmentRecord.dayFreq = command.data.head.dayFreq | "1"
          this.activeDiagRecord.treatmentRecord.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.chmedPrescription.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.chmedPrescription.dayFreq = command.data.head.dayFreq
          this.activeDiagRecord.chmedPrescription.stdPrescriptionCode = command.data.head.stdPrescriptionCode
          this.activeDiagRecord.chmedPrescription.doseNum = command.data.head.doseNum
          this.activeDiagRecord.chmedPrescription.positionCode = command.data.head.positionCode
          this.activeDiagRecord.chmedPrescription.positionName = command.data.head.positionName
          this.activeDiagRecord.chmedPrescription.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.chmedPrescriptionItemList = command.data.body.chmedPrescriptionItem
          // this.prescriptionForm.body.chmedItemList = command.data.body.chmedPrescriptionItem
          break
        case "copyMed":
          this.activeDiagRecord.medPrescription.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.medPrescription.dayFreq = command.data.head.dayFreq
          this.activeDiagRecord.medPrescription.doseNum = command.data.head.doseNum
          this.activeDiagRecord.medPrescription.positionCode = command.data.head.positionCode
          this.activeDiagRecord.medPrescription.positionName = command.data.head.positionName
          this.activeDiagRecord.medPrescription.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.medPrescriptionItemList = command.data.body.medPrescriptionItem
          break
        case "copyServe":
          this.activeDiagRecord.servePrescriptionItemList = command.data.body.servePrescriptionItem
          break
        default:
          break
      }
      this.cardShow = !this.cardShow
    },
    /**
     * 诊疗组件指令
     * @param command
     */
    handleTreatmentCommand(command) {
      switch (command.type) {
        case "finish":
          this.updateDiagRecord()
          this.updatePatientInfo()
          break
        default:
          break
      }
    },
    /**
     * 开方按钮点击
     */
    handleOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.tcmRx.open()
      })
    },
    handleOpenClick2() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.tcmRx2.open()
      })
    },
    handlePhyOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.PhysiotherapyRef.open()
      })
    },
    handleCPDOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.TcmRxCPDRef.open()
      })
    },
    /**
     * 开方
     */
    handleShow() {
    },
    /**
     * 开方选择
     * @param row
     */
    handlePopupClick(row) {
      console.log(row)
      this.activeDiagRecord.chmedPrescription.serveFeeSign = row.head["decoctSign"]
      this.activeDiagRecord.chmedPrescription.doseNum = row.head["doseNum"]
      this.activeDiagRecord.chmedPrescription.dayDoseNum = row.head["dayDoseNum"]
      this.activeDiagRecord.chmedPrescription.dayFreq = row.head["dayFreq"]
      this.activeDiagRecord.chmedPrescription.stdPrescriptionCode = row.head["code"]
      this.activeDiagRecord.chmedPrescriptionItemList = row.body["stdPrescriptionItem"].map((item, index) => {
        return {
          ...item,
          qualitySign: "1",
          doseNum: parseFloat(item["sellingNum"]) * parseFloat(row.head.doseNum),
          singleNum: item["sellingNum"]
        }
      })
    },
    handlePhysiotherapySelect(row) {
      console.log(row)
      // 理疗特有字段映射（根据实际接口返回调整）
      this.activeDiagRecord.servePrescriptionItemList.push({
        materielName: row.head.materielName,
        materielCode: row.head.materielCode,
        sellingNum: row.head.sellingNum,
        medAdvice: row.head.medAdvice,
        dayFreq: row.head.dayFreq,
        freqNum: row.head.freqNum
      })
    },
    handleMedicationSelect(row) {
      // 中成药特有字段映射
      this.activeDiagRecord.medPrescription = {
        ...this.activeDiagRecord.medPrescription,
        "positionCode": row.head.positionCode,
        "positionName": row.head.positionName,
        "totalQuantity": row.head.totalQuantity || 1 // 总数量
      }
      console.log(row)
      // 中成药明细列表
      this.activeDiagRecord.medPrescriptionItemList.push({
        materielName: row.head.materielName,
        materielCode: row.head.materielCode,
        sellingNum: row.head.sellingNum || 1,
        qualitySign: "1",
        medAdvice: row.head.medAdvice,
        dayFreq: row.head.dayFreq,
        freqNum: row.head.freqNum
      })
    },
    /**
     * 诊疗提交
     */
    handleTreatment() {
      this.$refs.treatment.handleTreatment()
    },
    /**
     * 挂号
     */
    enroll() {
      this.enrollVisible = true
    },
    /**
     * 挂号提交
     */
    handleEnroll() {
      this.$refs.enrollForm.submitEnrollForm()
    },
    /**
     * 挂号表单提交
     * @param command
     */
    handleEnrollCommand(command) {
      const url = "clinic/treatment/treatment/diagrecord/do/storeenroll"
      const pd = {
        ...command.data
      }
      postData(url, pd)
        .then(res => {
          this.$message.success("挂号成功!")
          this.enrollVisible = false
          this.updateDiagRecord()
        })
    },
    /**
     * 刷新预诊记录
     */
    updateDiagRecord() {
      this.$refs.patients.findDiagRecord()
    },
    /**
     * 刷新病人信息
     */
    updatePatientInfo() {
      this.$refs.patients.handleClickDiagRecord(this.activeDiagRecord.diagRecord)
    },
    printOpen() {
      const data = {
        data: this.activePatientInfo,
        body: this.activeDiagRecord
      }
      this.$refs.whitePrescribeModal.open(data)
    },
    saveChufang() {
      let url
      // 公共字段：初始化扁平化的pd对象
      const pd = {
        "code": this.activeDiagRecord.treatmentRecord.code,
        "stdPrescriptionCode": null
      }

      // 根据标签页补充对应处方字段（批量合并到pd）
      if (this.currentTreatmentTab === '4') { // 代煎处方
        url = "pharmacy/storage/agentpre/agentprescription/do/treatmentchmedprescription"

        // 过滤掉 materielName 为空的项
        const filteredDjItemList = this.activeDiagRecord.djPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )

        Object.assign(pd, {
          pharmacyCode: this.activeDiagRecord.djPrescription.pharmacyCode,
          pharmacyName: this.activeDiagRecord.djPrescription.pharmacyName,
          serveFeeSign: this.activeDiagRecord.djPrescription.serveFeeSign,
          doseNum: this.activeDiagRecord.djPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.djPrescription.dayDoseNum,
          dayFreq: this.activeDiagRecord.djPrescription.dayFreq,
          chmedItemList: filteredDjItemList
        })
      } else if (this.currentTreatmentTab === '5') { // 代售处方
        url = "pharmacy/storage/agentpre/agentprescription/do/treatmentmedprescription"

        // 过滤掉 materielName 为空的项
        const filteredDsItemList = this.activeDiagRecord.dsPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )

        Object.assign(pd, {
          pharmacyCode: this.activeDiagRecord.dsPrescription.pharmacyCode,
          pharmacyName: this.activeDiagRecord.dsPrescription.pharmacyName,
          doseNum: this.activeDiagRecord.dsPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.dsPrescription.dayDoseNum,
          medItemList: filteredDsItemList
        })
      } else if (this.currentTreatmentTab === '3') { // 理疗
        url = "clinic/treatment/treatment/diagrecord/do/treatmentserveprescription"

        // 过滤掉 materielName 为空的项
        const filteredServeItemList = this.activeDiagRecord.servePrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )

        Object.assign(pd, {
          medPositionCode: this.activeDiagRecord.medPrescription.positionCode,
          medPositionName: this.activeDiagRecord.medPrescription.positionName,
          serveItemList: filteredServeItemList
        })
      } else if (this.currentTreatmentTab === '2') { // 中成药处方
        url = "clinic/treatment/treatment/diagrecord/do/treatmentmedprescription"

        // 过滤掉 materielName 为空的项
        const filteredMedItemList = this.activeDiagRecord.medPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )

        Object.assign(pd, {
          medPositionCode: this.activeDiagRecord.medPrescription.positionCode,
          medPositionName: this.activeDiagRecord.medPrescription.positionName,
          medItemList: filteredMedItemList
        })
      } else { // 饮片处方
        url = "clinic/treatment/treatment/diagrecord/do/treatmentchmedprescription"

        // 过滤掉 materielName 为空的项
        const filteredChmedItemList = this.activeDiagRecord.chmedPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )

        Object.assign(pd, {
          chmedPositionCode: this.activeDiagRecord.chmedPrescription["positionCode"],
          doseNum: this.activeDiagRecord.chmedPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.chmedPrescription.dayDoseNum,
          dayFreq: this.activeDiagRecord.chmedPrescription.dayFreq,
          serveFeeSign: this.activeDiagRecord.chmedPrescription.serveFeeSign,
          chmedItemList: filteredChmedItemList,
          dayNum: this.activeDiagRecord.chmedPrescription.dayNum
        })
      }

      console.log(pd)
      postData(url, pd)
        .then(res => {
          this.$refs.treatment.getTreatmentRecord(res.data.code)
          this.$message.success("保存成功!")
        })
    },
    clearPrescription() {
      let url
      const pd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      if (this.currentTreatmentTab === '3') { // 理疗
        url = "clinic/treatment/treatment/diagrecord/do/removeserveprescription"
      } else if (this.currentTreatmentTab === '2') { // 中成药处方
        url = "clinic/treatment/treatment/diagrecord/do/removemedprescription"
      } else { // 饮片处方
        url = "clinic/treatment/treatment/diagrecord/do/removechmedprescription"
      }
      postData(url, pd).then(res => {
        console.log(res)
        this.$message.success('操作成功')
        this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
      })
    },
    clearInformation() {
      this.activePatientInfo = {}
    }
  }
}
</script>

<style scoped lang="scss">
.history-container {
  max-height: 100%; /* 设置最大高度为视窗高度的70% */
  display: flex;
  flex-direction: column;
  .flex-row {
    height: 100%;
  }
}
/* 历史记录部分样式 */
.history-section {
  height: 100%;
  overflow: hidden; /* 防止内部内容溢出 */
  display: flex;
  flex-direction: column;

  .history-content {
    flex: 1;
    overflow-y: auto; /* 添加垂直滚动条 */
    padding-right: 8px; /* 为滚动条留出空间 */

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
      &:hover {
        background: #a8a8a8;
      }
    }
  }
  .no-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .no-data-label {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
  }
}
  .history-timeline {
    padding: 10px 0;

    .history-item {
      margin-bottom: 16px;
      padding-right: 8px; /* 为滚动条留出空间 */
    }
  }
}

// 挂号区
.register-con {
  margin-right: 16px;
  width: 15%;
  .register-logo {
    width: 176px;
    height: 56px;
    margin-bottom: 12px;
  }

}

// 病人信息
.patient-con {
  width: 488px;
  margin-right: 16px;

  // 病人信息
  .info {
    margin-bottom: 16px;

    .info-con {
      padding: 16px;

      .profile {
        width: 64px;
        height: 64px;
        margin-right: 16px;

      }

      .info-wrapper {
        .name {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 20px;
          color: #1D2129;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 8px;
        }

        .info-item {
          .label {
            font-family: Roboto, Roboto, serif;
            font-weight: normal;
            font-size: 14px;
            color: #999999;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .value {
            font-family: Roboto, Roboto, serif;
            font-weight: normal;
            font-size: 14px;
            color: #4E5969;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .divider-line {
          height: 14px;
          border: 1px solid #E5E6EB;
          margin: 0 8px;
        }
      }

    }
  }

  // 诊断记录
  .diagnosis {
    flex: 1;
    // overflow-y: scroll;

    .diagnosis-con {
      .reDiag {
        flex: 1;
      }

      .dig-info {
        height: 65vh;
        // overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 0;
        }

        .date-picker {
          margin-bottom: 12px;
        }

        .diagnosis-record-con {
          .record {
            margin-bottom: 16px;
          }
        }
      }

      .no-data {
        height: 598px;

        .no-data-img {
          height: 170px;
          width: 170px;
        }

        .no-data-label {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #606C80;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }

}

.treatment-con {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 85%;
  overflow: auto;
  .item-con {
    .label-con {
      margin-bottom: 12px;

      .icon {
        width: 4px;
        height: 14px;
        background: #165DFF;
        border-radius: 0 0 0 0;
        margin-right: 8px;
      }

      .label {
        font-family: PingFang SC, PingFang SC, serif;
        font-weight: bold;
        font-size: 16px;
        color: #1D2129;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .divider-line {
    border-radius: 0 0 0 0;
    border: 1px solid #E5E6EB;
    margin: 10px 0;
  }

  .body {
  flex: 1; /* 填充卡片剩余空间 */
  min-height: 300px; /* 保证最小高度 */
  overflow: auto; /* 允许内容滚动 */

  /* 恢复滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
}
}

.add-btn-con {
  background: #FFFFFF;
  height: 46px;
  border: 1px solid #E5E6EB;
  padding: 7px;

  &:hover {
    cursor: pointer;
  }

  .add-btn {
    background: #F7F8FA;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;

    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.treatment-input {
  width: 180px;
}

::v-deep .el-timeline {
  padding: 2px;
}

::v-deep .el-input-number--small {
  line-height: 30px;
}

.pay-header {
  margin-bottom: 73px;

  .icon-img {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }

  .tip {
    font-family: 思源黑体 CN PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 24px;
    line-height: 22px;
  }
}

::v-deep .qrcode-con {
  background-image: url("../../../../../assets/list/qrcode.png");
  background-repeat: no-repeat;
  height: 676px;
  border-radius: 30px 30px 0 0;
  padding-top: 105px;
}
.treatment-body-card {
  flex: 1; /* 关键：自动填充剩余空间 */
  display: flex;
  flex-direction: column;

  /* 修复ElementUI卡片内边距 */
  ::v-deep .el-card__body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px; /* 根据实际需要调整 */
  }
}
/* 在index.vue的style中补充 */
.large-font-mode {
  /* 覆盖 Patients 组件 */
  .patients {
    .list-item {
      .name {
        font-size: 16px !important;
      }
      .info {
        font-size: 15px !important;
      }
    }
  }

  /* 覆盖 MedTable 组件 */
  .med-table {
    font-size: 16px;
    th, td {
      font-size: 16px !important;
      padding: 10px !important;
    }
  }

  /* 覆盖弹窗组件 */
  .el-dialog {
    font-size: 18px;
    .el-dialog__header {
      font-size: 20px;
    }
    .el-dialog__body {
      font-size: 18px;
    }
  }

  /* 覆盖处方打印相关 */
  .gh-table {
    font-size: 16px !important;
    th, td {
      font-size: 16px !important;
    }
  }

  /* 覆盖输入框和选择器 */
  .el-input__inner,
  .el-select,
  .el-textarea {
    font-size: 16px !important;
    padding: 8px 15px !important;
  }
}

/* 动态应用大字版样式 */
:root {
  &[data-large-font="true"] {
    font-size: 16px; /* 基础字体放大 */
  }
}

/* 修改现有样式以支持大字版 */
.treatment-con {
  &:global(.large-font) {
    .el-button {
      min-height: 40px;
      font-size: 16px;
    }

    .info-wrapper {
      font-size: 18px;

      .name {
        font-size: 24px;
      }
    }
  }
}

/* ==================== 患者信息头部 ==================== */
.patient-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  width: 100%;
}

/* 左侧区域 */
.header-left {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-shrink: 0; /* 防止左侧被压缩 */
}

.header-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid #f0f2f5;
}

.header-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  .patient-name {
    font-size: 20px;
    font-weight: 600;
    color: #1d2129;
    margin: 0;
    font-family: PingFang SC, sans-serif;
  }

  .patient-meta {
    font-size: 13px;
    color: #606266;
    background-color: #f2f3f5;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .patient-phone {
    font-size: 14px;
    color: #165dff;
    font-weight: 500;
    font-family: Roboto, sans-serif;
  }
}

.tag-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .el-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
}

/* 右侧区域 - 与按钮并排 */
.header-right {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0; /* 允许flex子项收缩 */
}

.info-line {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
  width: 100%;

  &.info-with-action {
    justify-content: space-between; /* 两端对齐：信息在左，按钮在右 */
    align-items: center;
    gap: 20px;
  }

  &.secondary-line {
    padding-left: 0;
    color: #86909c;
    font-size: 12px;
  }
}

.info-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.info-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  label {
    color: #909399;
    font-weight: normal;
    font-size: 12px;
  }

  value {
    color: #1d2129;
    font-weight: 500;
    font-size: 13px;

    /* 不同状态的颜色区分 */
    &.state-1 { color: #ff7d00; } /* 待诊断 - 橙色 */
    &.state-2 { color: #165dff; } /* 已开方 - 蓝色 */
    &.state-3 { color: #00b42a; } /* 已配药 - 绿色 */
    &.state-4 { color: #722ed1; } /* 待发药 - 紫色 */
  }
}

.divider {
  color: #e5e6eb;
  font-weight: 300;
  font-size: 12px;
}

/* 切换按钮样式 */
.switch-btn {
  flex-shrink: 0; /* 防止按钮被压缩 */
  font-weight: 500;
  padding: 7px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(22, 93, 255, 0.15);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(22, 93, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
}

.placeholder {
  flex: 1;
}

/* 响应式适配 - 小屏幕时堆叠 */
@media screen and (max-width: 1200px) {
  .patient-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-right {
    width: 100%;
    padding-left: 71px; /* 与左侧头像对齐 */
  }

  .info-with-action {
    flex-wrap: wrap;
    gap: 10px;

    .switch-btn {
      margin-left: auto; /* 尽可能靠右 */
    }
  }
}

@media screen and (max-width: 768px) {
  .info-with-action {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;

    .switch-btn {
      margin-left: 0;
      width: 100%;
    }
  }
}

/* 大字版模式适配 */
.large-font-mode {
  .patient-header {
    .patient-name {
      font-size: 24px;
    }
    .patient-meta, .patient-phone {
      font-size: 15px;
    }
    .info-item label, .info-item value {
      font-size: 15px;
    }
    .header-avatar {
      width: 72px;
      height: 72px;
    }
    .switch-btn {
      font-size: 14px;
      padding: 9px 18px;
    }
  }
}

/* 体质标签特殊样式 */
.tizhi-tag {
  font-weight: 500;
  border-radius: 4px;
  margin: 0 8px;
  i {
    margin-right: 4px;
    font-size: 12px;
  }

  /* 不同体质的颜色自定义（覆盖 Element 默认） */
  &.el-tag--success {
    background-color: #00b42a;
    border-color: #00b42a;
  }
  &.el-tag--warning {
    background-color: #ff7d00;
    border-color: #ff7d00;
  }
  &.el-tag--danger {
    background-color: #f53f3f;
    border-color: #f53f3f;
  }
  &.el-tag--info {
    background-color: #86909c;
    border-color: #86909c;
  }
}

/* 调整 info-row 间距，适应新增的体质标签 */
.info-row {
  gap: 8px; // 减小默认间距

  .patient-name {
    margin-right: 4px;
  }

  .patient-meta {
    margin-right: 4px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
